<template>
	<div class="container">
		<div class="content_box">
			<div class="left_box">
				<div class="headers">
					<div class="nav_bar" style="display: flex;align-items: center;">
						<router-link to="/">
							<img src="images/index.png" />首页
						</router-link>＞
						<router-link to="/">
							{{name}}
						</router-link>
					</div>
					<div class="sjtitle_box">
						<div>
							<div class="big_text">{{name}}</div>
							<!-- <div class="time_tj">
								<div>交卷时间：2022-02-07 09:46:51</div>
								<div>答题用时：8分13秒</div>
								<div>平均答题用时：16分10秒</div>
							</div> -->
							<div>
								
							
							
							</div>

							
						</div>
						<div class="user_number" v-if="score.score"><span class="big">{{score.score}}</span>分
						</div>
					</div>
				</div>
				<div class="left_content">
					<div class="content_tit">
						<div class="title_active">
							<div :class="current == 0?'active':'' " @click="currentClick(0)">错题解析</div>
							<div :class="current == 1?'active':'' " @click="currentClick(1)">全部解析</div>
						</div>
						<div class="qq"  >
								<a  href="http://wpa.qq.com/msgrd?v=3&uin=646913261&site=qq&menu=yes"  target="_black">
								<img src="../../../public/images/an_12.png">
						  	加入答疑QQ群
					</a>
						</div>
					</div>
					<div class="answer_box" v-if="current == 0">
						<div class="answer_list" v-for="(item,index) in errorList" :id="'page'+index">
							<analysis :answer="item" :index="index" :type="types" :ques_id="ques_id" @collect="collect">
							</analysis>
						</div>
					</div>
					<div class="answer_box" v-if="current == 1">
						<div class="answer_list" v-for="(item,index) in answerList" :id="'page'+index">
							<analysis :answer="item" :index="index" :type="types" :ques_id="ques_id" @collect="collect">
							</analysis>
						</div>
					</div>
					<!-- <div class="answer_box" >
						<div class="answer_list" v-for="(item,index) in answerList">
							<analysis :answer="item"></analysis>
						</div>
					</div> -->
				</div>
			</div>
			<div class="right_box">
				<div class="right_title" 　　v-if="score.exceed">　
					<div class="numbers" v-if="score.ranking">
						<div>
							<div>{{score.ranking}}</div>
							<div>排名</div>
						</div>
						<div style="margin-top: 15px;">
							<div>{{score.average}}</div>
							<div>平均分</div>
						</div>
					</div>
					<div class="result-pro" 　v-if="score.exceed">
						<p>
							<em>
								<b>{{score.exceed}}</b>%
							</em>超过人数
						</p>
						<el-progress type="circle" :percentage="Number(score.exceed)<=0 ? 0.1:Number(score.exceed)"
							:width="130" :stroke-width="12" color="#e60012" :show-text="false"></el-progress>
					</div>
				</div>
				<div class="answer-card" id="boxFixed" :class="{'is_fixed' : isFixed}">
					<h3>
						<img src="images/an_7.png" /> 答题卡
					</h3>
					<div class="card card-a">
						<el-button v-for="(item,index) in (current == 0?errorList:answerList)" :key="index"
							@click="jumpClick(index)"
							:style="item.answer !== item.user_answer?'background:#ff6c6c;color:#fff;border:none':'background:#10aeff;color:#fff;border:none'">
							{{index+1}}
						</el-button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import analysis from '../../components/analysis.vue'
	export default {
		components: {
			analysis
		},
		data() {
			return {
				current: 0,
				answerList: [], //全部题目数组
				errorList: [], //错题数组
				result_id: '',
				xuanran: [],
				types: '',
				ques_id: '',
				name: '',
				showWrongWin: false,
				score: {},
				offsetTop: 0,
				isFixed: false,
				resultData: [], //组合后的数组
			}
		},
		created() {
			this.result_id = this.$route.query.result_id;
			this.types = this.$route.query.type;
			this.ques_id = this.$route.query.ques_id;
			this.getData()
			window.localStorage.removeItem(`${this.ques_id}`)
			




		},
		mounted() {
			window.addEventListener('scroll', this.initHeight)
			this.$nextTick(() => {
				this.offsetTop = document.querySelector('#boxFixed').offsetTop;
			})
		},
		methods: {
			initHeight() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.isFixed = scrollTop > this.offsetTop ? true : false;
			},
			jumpClick(index) {
				var PageId = document.querySelector('#page' + index)
				window.scrollTo({
					'top': PageId.offsetTop - 80,
					'behavior': 'smooth'
				})
			},
			destroyed() {
				window.removeEventListener('scroll', this.handleScroll)
			},
			collect(e) {
				//console.log(e)
				if (this.current == 0) {
					if (e.type == 'yes') {
						this.errorList[e.index].collect = 1
					} else {
						this.errorList[e.index].collect = 0
					}
				} else {
					if (e.type == 'yes') {
						this.answerList[e.index].collect = 1
					} else {
						this.answerList[e.index].collect = 0
					}
				}
				if (e.type == 'yes') {
					this.xuanran[e.index].collect = 1
				} else {
					this.xuanran[e.index].collect = 0
				}
			},
			getData() {

				
				this.$loading(true);
				var that =this
				var param = {
					id: this.result_id,
					type: this.types
				};
				this.$api.getAnswerAnalysis(param).then(res => {
					this.answerList = res.data.info;
					this.name = res.data.ques.name
					this.$api.getAnswerResult({
						id: this.result_id,
						type: this.types
					}).then(req => {
						this.score = req.data.score
						this.resultData = req.data.resultData
						this.resultData.map((item, index) => {
							that.answerList[index]['user_answer'] = item['user_answer']
							this.answerList[index]['is_right'] = item['is_right']
							this.answerList[index]['id'] = item['id']
							this.answerList[index]['list_id'] = item['list_id']
						})
						this.errorList = this.answerList.filter(item => {
							return item.answer !== item.user_answer
						})
						this.$loading().close();

					})
				})

			},
			currentClick(index) {
				this.current = index
				this.$forceUpdate()
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.is_fixed {
		position: fixed;
		top: 80px;
		// left: 50%;
		background: #fff;
		z-index: 999;
	}

	.contaienr {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	// .card-a {
	// 	position: sticky;
	// 	top: 0;
	// 	z-index: 999;
	// }

	.content_box {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		

		.left_box {
			width: 900px;

			.headers {
				background: #fff;
				padding: 30px;

				.nav_bar {
					align-items: center;
					padding-bottom: 30px;
					border-bottom: 1px solid #eee;
					color: #666;
				}
				.nav_bar a{
					display: flex;
					align-items: center;
				}

				.sjtitle_box {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding-top: 30px;

					.big_text {
						font-size: 20px;
						color: #333;
						margin-bottom: 10px;
					}

					.time_tj {
						display: flex;
						align-items: center;
						justify-content: flex-start;
						color: #999;

						div {
							margin-left: 30px;
						}

						div:first-child {
							margin-left: 0 !important;
						}
					}

					.user_number {
						color: #14cf6c;
						font-size: 24px;

						.big {
							font-size: 32px;
							font-weight: bold;
						}
					}
				}
			}

			.left_content {
				margin-top: 30px;
				background: #fff;

				.content_tit {
					display: flex;
					justify-content: space-between;
					height: 65px;
					padding: 0 30px;
					border-bottom: 1px solid #eee;

					.qq {
						display: flex;
						align-items: center;
						color: #e60012;
						font-size: 16px;
						cursor: pointer;
					}
				}

				.title_active {
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 16px;
				}

				.title_active div {
					padding: 20px;
				}

				.title_active .active {
					background: url('../../../public/images/icon_1.png') bottom no-repeat;
					background-size: 100% 8px;
					color: #333;
				}

				.answer_box {
					padding: 30px;

					.answer_list {
						margin-bottom: 20px;
						border-bottom: 1px solid rgb(155, 149, 149);

					}
				}
			}
		}

		.right_box {
			width: 280px;

			.right_title {
				height: 180px;
				background: #fff;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 20px;
				box-sizing: border-box;

				.result-pro {
					width: 130px;
					position: relative;
				}

				.numbers {
					text-align: center;

					div div:nth-child(1) {
						font-size: 24px;
						font-weight: bold;
						color: #333;
					}
				}

				.result-pro p {
					position: absolute;
					z-index: 100;
					color: #999;
					font-size: 12px;
					text-align: center;
					width: 100%;
					top: 40px;
				}

				.result-pro em {
					display: block;
					font-size: 16px;
					color: #333;
				}

				.result-pro b {
					font-size: 36px;
				}

			}

			.answer-card {
				background: #fff;
				margin: 20px auto auto auto;
			}

			.answer-card h3 {
				font-size: 18px;
				padding: 20px;
				border-bottom: 1px solid #ebebeb;
			}

			.answer-card h3 img {
				margin-right: 5px;
			}

			.card {
				width: 250px;
				
				margin: 20px 0px 0 16px;
				overflow-y:auto !important
			
			}

			.card .el-button {
				width: 25px;
				height: 25px;
				padding: 0;
				border: 1px solid #999;
				color: #666;
				border-radius: 4px;
				text-align: center;
				line-height: 25px;
				margin: 0 0 10px 10px !important;
			}

			.card .right {
				color: #fff;
				background-color: #10aeff;
				border-color: #10aeff;
			}

			.card .wrong {
				color: #fff;
				background-color: #ff6c6c;
				border-color: #ff6c6c;
			}

			.card .el-button:nth-child(7n+1) {
				margin: 0 0 20px 0 !important;
			}

			.answer-card p {
				margin: 0 20px;
				overflow: hidden;
				font-size: 16px;
				padding-bottom: 20px;
			}

			.answer-card .el-form {
				padding: 0;
			}

			.answer-card .el-select {
				width: 100%;
			}

			.answer-card .el-form-item {
				margin-bottom: 0;
			}

		}

		.card-a {
			overflow-y: scroll !important;
			max-height: 790px !important;
		}

		.card-a::-webkit-scrollbar {
			/*滚动条整体样式*/

			width: 5px;
			/*高宽分别对应横竖滚动条的尺寸*/

			height: 1px;

		}

		// .card-a::-webkit-scrollbar-track {
		// 	background-color: red;
		// 	-webkit-border-radius: 2em;
		// 	-moz-border-radius: 2em;
		// 	border-radius: 2em;
		// }

		// .card-a::-webkit-scrollbar-thumb {
		// 	background-color: #191919;
		// 	-webkit-border-radius: 2em;
		// 	-moz-border-radius: 2em;
		// 	border-radius: 2em;
		// }
	}
</style>
